import SectionNavigation from "@/Utility/SectionNavigation";
import { PROJECT_TAB_NAV_ITEMS } from "./projectNavigation.mapper";

const ProjectNavigation = ({ activeTab, onTabChange, items = PROJECT_TAB_NAV_ITEMS }) => {
  return (
    <SectionNavigation
      items={items}
      activeTab={activeTab}
      onTabChange={onTabChange}
      iconSize={16}
    />
  );
};

export default ProjectNavigation;
